import { Route, Routes } from "react-router-dom";

import { FieldManagementReports } from "./";
import { EmeddedFMReport } from "./EmeddedFMReport";

export const FmReportsRouter = () => {
  return (
    <Routes>
      <Route path=":reportName" element={<EmeddedFMReport />} />
      <Route path="*" element={<FieldManagementReports />} />
    </Routes>
  );
};
